
const initialState = {
  data:{},
  permission:{}
}

const LoginReducer = (state = initialState, action) => {
    switch (action.type) {

        case "userdata":
        return {
            ...state,
            data: action.payload.data,
            permission: action.payload.permission,
        }
        
        default: return state

    }
}

export default LoginReducer